module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "d7e118715"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "2",
      "src": "images/2.jpg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c18_r1#Anch00115",
      "id": "Anch0005"
    }
  }, [_vm._v("PART I")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "2",
      "src": "images/2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imgpub"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "1",
      "src": "images/1.jpg"
    }
  })]), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "d9t00115"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c18_r1#Anch00115",
      "id": "Anch001105"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISDOM FOR")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _c('br'), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROFESSIONAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")])])]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d7e121115"
    }
  }, [_c('i', [_vm._v("Wisdom is the principal thing; "), _c('br'), _vm._v("therefore get wisdom.")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("—Proverbs 4:7 ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("KJV")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04c6dd05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mark_9781595553966_epub_c20_r1.vue
// module id = 72
// module chunks = 0